import * as moment from "moment";
import * as momentTimezone from "moment-timezone";

const getUsersTimeZone = () => {
    // guess() uses the browser's Internationalization API to get the user's time guessedZoneId.
    const guessedZoneId = momentTimezone.tz.guess();
    const guessedZone = momentTimezone.tz(guessedZoneId);
    const zoneShortName = guessedZone.format("z");
    const zoneNumeric = guessedZone.format("Z");
    return zoneShortName + " (UTC " + zoneNumeric + ")";
};

export const getTimeZoneUtcOffset = () => {
    return moment().utcOffset();
};

export const getUserTimeZoneId = () => {
    return momentTimezone.tz.guess();
};

export const getTimeZoneText = () => `All times are in ${getUsersTimeZone()}`;
